/* eslint-disable @typescript-eslint/no-misused-promises */
'use client'

import { OptimizedImage } from '@/app/ui/parts/default/common/originalImage'
import { deleteLike } from '@/lib/like'
import { handleUserBehavior } from '@/lib/user_behavior/client'
import useImpressionObserver from '@/lib/user_behavior/use_impression_observer'

export const ImpressionObserver = ({
  item_id,
  price,
}: {
  item_id: number
  price: number
}) => {
  const ref = useImpressionObserver(item_id, price)

  return <div ref={ref}></div>
}

export const DeleteLikeButton = ({
  service_id,
  item_id,
}: {
  service_id: string
  item_id: number
}) => {
  return (
    <div
      className="absolute right-1 top-1 rounded-full w-9 h-9 flex justify-center items-center z-10"
      style={{ backgroundColor: '#999', color: '#fff' }}
      onClick={async () => {
        await deleteLike(service_id, item_id)
      }}
    >
      <p className="text-xl">×</p>
    </div>
  )
}

export const MainImageWithOptimized = ({
  item_id,
  image_url,
  name,
  price,
}: {
  item_id: number
  image_url: string
  name: string
  price: number
}) => {
  return (
    <a
      href={`/item/${item_id}`}
      className="item-card-image-container"
      onClick={async () => {
        await handleUserBehavior(item_id, 'click', price)
      }}
    >
      <OptimizedImage
        src={image_url}
        alt={name}
        height={200}
        width={200}
        className="item-card-image w-full h-full object-cover"
      />
    </a>
  )
}
